import { BYOCComponent } from './BYOCComponent';
import React from 'react';
export const BYOC_WRAPPER_RENDERING_NAME = 'BYOCWrapper';
export const BYOCWrapper = (props) => {
    var _a, _b, _c;
    const styles = (_b = (_a = props.params) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.trimEnd();
    const id = (_c = props.params) === null || _c === void 0 ? void 0 : _c.RenderingIdentifier;
    return (React.createElement("div", { className: styles ? styles : undefined, id: id ? id : undefined },
        React.createElement("div", { className: "component-content" },
            React.createElement(BYOCComponent, Object.assign({}, props)))));
};
